module.exports = __webpack_public_path__ + "img/8.e1d69f45.png";